import refetchToken from "./refetchToken";
import axiosInstance from "./axiosInstance";
import {clearStoredAuth, persistAuthTokens, readStoredAuthTokens} from "./authStorage";

const clearAuthAndRedirect = () => {
    clearStoredAuth();
    delete axiosInstance.defaults.headers.common['Authorization'];

    if (window.location.pathname !== '/login') {
        window.location.assign('/login');
    }
};

const normalizeArguments = (refreshToken, refetch, options) => {
    if (typeof refreshToken === 'function' && !refetch) {
        return {
            refreshToken: readStoredAuthTokens().refreshToken,
            refetch: refreshToken,
            options: options || {},
        };
    }

    return {
        refreshToken,
        refetch: typeof refetch === 'function' ? refetch : undefined,
        options: options || {},
    };
};

const handleUnauthorized401QueryError = async (error, refreshToken, refetch, options) => {
    if(error?.response?.status === 401){
        const normalized = normalizeArguments(refreshToken, refetch, options);
        const onUnauthorized = normalized.options.onUnauthorized || clearAuthAndRedirect;

        if (!normalized.refreshToken) {
            onUnauthorized();
            return true;
        }

        try {
            const res = await refetchToken(normalized.refreshToken);
            const newAccessToken = res?.data?.access;

            if (!newAccessToken) {
                throw new Error('Token refresh did not return an access token.');
            }

            persistAuthTokens({
                accessToken: newAccessToken,
                refreshToken: normalized.refreshToken,
            });
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`
            normalized.options.onTokenRefreshed?.(newAccessToken);
            await normalized.refetch?.();
            // queryClient.invalidateQueries()
        } catch (refreshError) {
            onUnauthorized(refreshError);
        }

        return true;
    }

    return false;
};

export default handleUnauthorized401QueryError
